import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=78e53f30&scoped=true&"
import script from "./UserCenter.vue?vue&type=script&lang=js&"
export * from "./UserCenter.vue?vue&type=script&lang=js&"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=78e53f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e53f30",
  null
  
)

export default component.exports